<template>
    <div class="wrap">
        <select
            :id="id"
            ref="input"
            v-model="inputSelectValue"
            :aria-invalid="ariaInvalid"
            :aria-describedby="ariaErrormessage"
            class="input"
            :name="name"
        >
            <option disabled value=""></option>
            <option
                v-for="item in items"
                :key="item.value"
                :value="item.value"
            >{{ item.title }}</option>
        </select>
        <span class="icon">
            <font-awesome-icon icon="angle-down" />
        </span>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: null,
            required: false
        },
        ariaInvalid: {
            type: String,
            default: null,
            required: false
        },
        ariaErrormessage: {
            type: String,
            default: null,
            required: false
        },
        items: {
            type: Array,
            required: true
        },
        value: {
            type: [Number, String],
            default: null,
            required: false
        },
        name: {
            type: String,
            default: null
        }
    },
    computed: {
        inputSelectValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("input", newValue);
            }
        }
    }
};
</script>

<style scoped lang="scss">
$input-Dropdown-font: $input-font !default;
$input-Dropdown-color: $input-color !default;
$input-Dropdown-highlight-background: rgba(0, 0, 0, 0.1) !default;
$input-Dropdown-disabled-font: $input-Dropdown-font !default;
$input-Dropdown-disabled-color: rgba($input-Dropdown-color, 0.5) !default;
$input-Dropdown-dropdown-background: #fff !default;
$input-Dropdown-dropdown-font: $input-Dropdown-font !default;
$input-Dropdown-dropdown-color: $input-Dropdown-color !default;

.wrap {
    position: relative;
    z-index: 0;
}

.input {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    border: none;
    width: 100%;
    font: $input-font;
    color: $input-color;
    line-height: 1.6em;
    padding: 0;
    outline: none;
    flex-grow: 1;

    /* needed for autofill hack */
    background: rgba(0, 0, 0, 0);
}

.icon {
    position: absolute;
    right: 0;
    top: calc(50% - 11px);
    z-index: -1;
}

.input:-webkit-autofill,
.input:-webkit-autofill:hover,
.input:-webkit-autofill:focus,
.input:-webkit-autofill:active {
    -webkit-transition-delay: 99999s;
}
</style>
